

import React from 'react'
import Text from './Text'

/**
 * Toggle component.
 */

export default function Toggle({ label, ...props }) {
  return <label className="Toggle">
    <input type="checkbox" {...props} />
    <i className="icon"></i> <Text muted>{label}</Text>
  </label>
}

   